<template>
	<div id="appAuthorize" class="d-flex flex-column align-items-center">
		<div class="p-2">
			<div class="spinner"></div>
		</div>
		<div class="p-2 text-center">{{message}}</div>
	</div>
</template>

<script>
import { Auth } from "@/services";

export default {
  name: "loginAuthorize",
  data() {
    return {
			message: this.$t('VerifyingAuthentication') + ' ' + this.$t('PleaseWait')
    };
  },
  created() {
		const params = this.$route.params
		
		localStorage.setItem("Authorization", params.authorizationToken);
		Auth.setToken(params.authorizationToken);

		Auth.verify()
		.then(response => response.data)
		.then(data => Auth.setUser(data))
		.then(() => this.$router.push({ name: "patientExams" }))
		.then(() => {
			if(this.$ga)
				this.$ga.event({
					eventCategory: 'login',
					eventAction: 'login-widget',
					eventLabel: 'Autenticação site externo'
				})
		})
		.catch(error => {
			this.message = this.$t('AuthorizationFailedTryAgain');
			setTimeout(() => window.close(), 3000);
		})
	}
};
</script>

<style lang="scss" scoped>
.spinner {
  width: 40px;
  height: 40px;
  background-color: #333;

  border-radius: 100%;
  -webkit-animation: sk-scaleout 1s infinite ease-in-out;
  animation: sk-scaleout 1s infinite ease-in-out;
}

@-webkit-keyframes sk-scaleout {
  0% {
    -webkit-transform: scale(0);
  }
  100% {
    -webkit-transform: scale(1);
    opacity: 0;
  }
}

@keyframes sk-scaleout {
  0% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/login/loginAuthorize.vue